require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./you-only-live-once-3.json") })
        }
      }, "path---you-only-live-once-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---you-only-live-once-3!./.cache/json/you-only-live-once-3.json
// module id = 857
// module chunks = 231608221292675